// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const editOrgUserAccessMutation = gql`
  mutation editOrgUserAccess($input: EditOrgUserAccessInput!) {
    editOrgUserAccess(input: $input) {
      code
      message
      success
    }
  }
`;
